import styled from 'styled-components'

import { InputError as DefaultInputError } from '../Shared'

export const InputError = styled(DefaultInputError)`
	margin-top: 8px;
	padding: ${({ hasError }) => (hasError ? '8px' : '0 8px')};
`
